module.exports = "<app-nav [currentAppLabel]=\"currentAppLabel\" [menuHeaderData]=\"menuHeaderData\"\n         (selected)=\"selectedProgram($event)\"></app-nav>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/app-layout/app-layout.component.html
// module id = ./src/app/core/components/app-layout/app-layout.component.html
// module chunks = main